'use client';
import style from './style.module.scss';
import SafeLink from '@/components/SafeLink';
import AnnouncementSVG from '@/assets/icons/announcement.svg';
import ArrowRight from '@/assets/icons/ArrowRight.svg';
import { spmTrackingUtils } from '@/intl-jdi-common-ssr/utils/spmTrackUtils';

export default function Module({ moduleData }: { moduleData: any }) {
  const PageConfig: any = {};
  const initConfig = (moduleData: any) => {
    PageConfig.data = moduleData?.externalData?.data?.announcementList || [];
  };

  initConfig(moduleData);

  if (!PageConfig.data) {
    return null;
  }
  return (
    <div
      className={style['uk-announcement']}
      onClick={(e) => {
        spmTrackingUtils.spmClick({
          spm: 'a0145.b002218.c00002836.notification',
          event_id: 'Home_Notification',
          page_id: 'Home_Main',
          target: e.target as HTMLElement,
          json_param: JSON.stringify({
            title: PageConfig.data[0]?.title || '-100',
            id: PageConfig.data[0]?.id || '-100',
            url: `${PageConfig.data[0]?.url}`,
          }),
        });
      }}
      data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
      data-exp={JSON.stringify({
        spm: 'a0145.b002218.c00002836.notification',
        event_id: 'Home_Notification_Expo',
        page_id: 'Home_Main',
        json_param: {
          title: PageConfig.data[0]?.title || '-100',
          id: PageConfig.data[0]?.id || '-100',
          url: `${PageConfig.data[0]?.url}`,
        },
      })}
    >
      <SafeLink href={`${PageConfig.data[0]?.url}`}>
        <div className={style.container}>
          <span className={style.messageContainer}>
            <span className={style.announcementIcon}>
              <AnnouncementSVG />
            </span>
            <span className={style.message}>{PageConfig.data[0]?.title}</span>
          </span>
          <ArrowRight />
        </div>
      </SafeLink>
    </div>
  );
}
